<template>
  <div>
    <a-modal
      v-show="!ishand"
      id="warp_sim12"
      width="40rem"
      v-model="visible"
      on-ok="handleOk1"
      v-dragModal
      @cancel="handleCancel(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      :dialog-style="{top: 22 +'%'}"
    >
      <div class="mark-file">
        <div
          style="
            background-color: #0c8b97;
            border-radius: 10px 10px 0 0;
            color: #fff;
            width: 38rem;
            margin: 1rem 1rem 0 1rem;
            text-align: center;
          "
        >
          <span v-if="stateFlag == 1">添加客戶信息</span>
          <span v-if="stateFlag == 3">编辑客戶信息</span>
        </div>
      </div>
      <div solt="title" style="position: relative">
        <!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
      </div>
      <div class="content">
        <div style="padding-top: 2.5rem; position: relative; left: -0.8rem">
          <a-form-model
            ref="ruleForm"
            :model="form"
            labelAlign="right"
            layout="inline"
            hideRequiredMark
            :rules="rules"
          >
            <a-row>
              <a-col :span="12">
                <a-form-model-item prop="securitiesAccount" ref="securitiesAccount" label="證券帳號">
                  <a-input
                    v-model="form.securitiesAccount"
                    placeholder="請輸入證券帳號"
                    auto-complete="new-accounts"
                    :maxLength="7"
                    :disabled="stateFlag == 3"
                     @change="
                      form.securitiesAccount = form.securitiesAccount.replace(/[^0-9]+/g, '')
                    "
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="chineseName" label="中文名稱">
                  <a-input
                    v-model="form.chineseName"
                    placeholder="請輸入中文名稱"
                    :disabled="stateFlag == 2"
                    onkeyup="value=value.replace(/[^\u4e00-\u9fa5]/g,'')"/>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item prop="englishName" label="英文名稱">
                  <a-input
                    v-model="form.englishName"
                    placeholder="請輸入英文名稱"
                    :disabled="stateFlag == 2"
                    onkeyup="value=value.replace(/[^a-z A-Z]/g,'')" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="phoneNumber" label="電話號碼" class="phoneSty">
                  <a-input
                    v-model="form.phoneNumber"
                     @change="
                      form.phoneNumber = form.phoneNumber.replace(/[^0-9]+/g, '')
                    "
                    auto-complete="new-password"
                    :maxLength="form.notai == '852' ? '8' : '11'"
                    placeholder="請輸入電話號碼"
                    :disabled="stateFlag == 2"
                  >
                  <div style="margin-right: 0.5rem;position: relative;width: 80px;"  slot="prefix">
                    <a-select
                      id="warp_input"
                      @change="qhclick"
                      :disabled="stateFlag == 2"
                      v-model="form.notai"
                      :getPopupContainer="
                        (triggerNode) => {
                          return triggerNode.parentNode;
                        }
                      "
                      >>
                      <a-select-option
                        v-for="item in qhArr"
                        :key="item.id"
                        :label="item.value"
                        :value="item.value"
                      >
                        <span style="font-size: 16px; float: left" v-if="item.id!=12">+{{ item.value }}</span>
                        <span style="font-size: 16px; float: left" v-else>{{ item.label }}</span>
                      </a-select-option>
                    </a-select>
                    <div style="position: absolute;color: #606266;top: 3px;left:1px;height: 80%;display: flex;align-items: center;justify-content: center;
                          width: 70%;background: #fff;border-radius: 4px;">
                      <div v-if="!qhflag">+{{form.notai}}</div>
                      <div class="qh_input" v-else style="display: flex;align-items: center;justify-content: center;">
                        <div style="margin-left: 10px;font-size: 16px;">+</div>
                        <a-input onkeyup="value=value=value.replace(/[^\d]/g,'')" :maxLength="3" v-model="form.notai" wi/>
                      </div>
                    </div>
                  </div>
                  </a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item prop="emailAddress" label="電郵地址">
                  <a-input
                    v-model="form.emailAddress"
                    placeholder="請輸入電郵地址"
                    :disabled="stateFlag == 2"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="identityInformation" label="身份信息">
                  <a-input
                    v-model="form.identityInformation"
                    placeholder="請輸入身份信息"
                    :disabled="stateFlag == 2"
                    :maxLength="21"
                    @change="
                    form.identityInformation = form.identityInformation.replace(/[^a-zA-Z0-9]+/g, '')
                  "
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item prop="bankName" label="銀行名稱">
                  <a-input
                    v-model="form.bankName"
                    placeholder="請輸入銀行名稱"
                    :disabled="stateFlag == 2"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="bankNumber" label="銀行號碼">
                  <a-input
                    v-model="form.bankNumber"
                    onkeyup="value=value.replace(/[^\d]/g,'') "
                    placeholder="請輸入銀行號碼"
                    :disabled="stateFlag == 2"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item prop='birth' label="出生日期">
									<a-date-picker v-model="form.birth" :disabled-date="disabledDate" class='warp_width' placeholder='請選擇出生日期' />
								</a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="nationality_en" label="國籍(英文)">
                  <a-input
                    v-model="form.nationality_en"
                    placeholder="請輸入國籍(英文)"
                    :disabled="stateFlag == 2"
                    onkeyup="value=value.replace(/[^a-z A-Z]/g,'')" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item prop='residential_nationality_cn' label="居住國家">
                  <!-- <a-input
                    v-model="form.residential_nationality_cn"
                    placeholder="請輸入居住國家"
                    :disabled="stateFlag == 2"
                    /> -->
                  <Situationall v-model="form.residential_nationality_cn"
                    :placeholder="placeholderVal"
										:url='$api.getCustomerCountryOfResidence'
										:disabled='!userfileAuditAdmin'
										:valonce='JSON.parse(JSON.stringify(form)).residential_nationality_cn'
										:params='{"type":"residential_nationality_cn"}'
										:style='"width: 100%;"'>
									</Situationall>
								</a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col>
                <a-form-model-item
                  prop="addressInformation"
                  label="地址信息"
                  class="address"
                >
                  <a-input
                    v-model="form.addressInformation"
                    placeholder="請輸入地址信息"
                    :disabled="stateFlag == 2"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col>
                <a-form-model-item
                  prop="address_en"
                  label="英文地址"
                  class="address"
                >
                  <a-input
                    v-model="form.address_en"
                    placeholder="請輸入英文地址"
                    onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'')"
                    :maxLength="130"
                    show-count
                    :disabled="stateFlag == 2"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
        <div style="text-align: center" v-if="stateFlag != 2 && userfileAuditAdmin">
          <button
            class="btn1 btnx"
            @click="handleCancel(1)"
            v-html="'提&emsp;&emsp;交'"
          ></button>
        </div>
      </div>
      <div style="width: 100%; height: 1px"></div>
    </a-modal>
  </div>
</template>

<script>
import App from "@/assets/app.js";
import dayjs from 'dayjs';
export default {
  props: ["items",'stateFlag'],
  data() {
    return {
      placeholderVal:'請輸入居住國家',
      qhflag: false,
      ishand: false,
      visible: true,
      flag:'',
      form: {
        birth: "",
        securitiesAccount: "",
        chineseName: "",
        englishName: "",
        phoneNumber: "",
        notai: "86",
        emailAddress: "",
        identityInformation: "",
        bankName: "",
        bankNumber: "",
        addressInformation: "",
        nationality_en: "",
        address_en: "",
        residential_nationality_cn: "",
      },
      rules: {
        securitiesAccount: [{ required: true, message: "" }],
        chineseName: [{ required: true, message: "" }],
        englishName: [{ required: true, message: "" }],
        nationality_en: [{ required: true, message: "" }],
        phoneNumber: [{ required: true, message: "" }],
        emailAddress: [{ required: true, message: "" }],
        identityInformation: [{ required: true, message: "" }],
        birth: [{required: true,message: ' ',trigger: 'change'}],
        residential_nationality_cn: [{ required: true, message: "" }],
      },
      // 手機區號列表
      qhArr: [
        {
          id: "1",
          value: "86",
          label: "中國",
        },
        {
          id: "2",
          value: "852",
          label: "中國香港",
        },
        {
          id: "3",
          value: "853",
          label: "中國澳門",
        },
        {
          id: "11",
          value: "886",
          label: "中國台灣",
        },
        {
          id: "4",
          value: "61",
          label: "澳大利亞",
        },
        // {
        // 	id: '5',
        // 	value: '1',
        // 	label: '加拿大'
        // },
        {
          id: "6",
          value: "60",
          label: "馬來西亞",
        },
        {
          id: "7",
          value: "1",
          label: "美國",
        },
        {
          id: "8",
          value: "65",
          label: "新加坡",
        },
        {
          id: "9",
          value: "64",
          label: "新西蘭",
        },
        {
          id: "10",
          value: "44",
          label: "英國",
        },
        {
          id: "12",
          value: "",
          label: "其他",
        },
      ],
      userfileAuditAdmin: this.$store.state.rolesdata.indexOf("userfileAuditAdmin") >= 0,
    };
  },
  mounted() {
    console.log(this.items, "彈窗",this.stateFlag);
    console.log("权限",this.userfileAuditAdmin);
    this.form.securitiesAccount = this.items.username;
    this.form.chineseName = this.items.cn_name;
    this.form.englishName = this.items.en_name;
    this.form.phoneNumber = this.items.phonenum;
    this.form.notai = this.items.nationcode!=undefined? this.items.nationcode : this.form.notai;
    this.form.emailAddress = this.items.email;
    this.form.identityInformation = this.items.id_number;
    this.form.bankName = this.items.bank;
    this.form.bankNumber = this.items.bank_number;
    this.form.addressInformation = this.items.address;
    if(this.stateFlag == 1){
      this.flag = 'new'
    }
  },
  methods: {
    qhclick(val){
      if(!val){
        this.qhflag = true
      }else{
        this.qhflag = false
      }
    },
    disabledDate(current) {
      var now = '1918-01-01';
      var nows = '2005-01-01'
      var moment = this.$moment(now,'YYYY-MM-DD');
      var moments = this.$moment(nows,'YYYY-MM-DD');
      // return current < moment || current > moments; 限制18岁之前不可选
      return current < moment || current > this.$moment().endOf("day");
    },
    formatDatefn(date, ste) {
      // var date = ds._d
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      if (ste) {
        return y + '/' + m
      } else {
        return y + '-' + m + '-' + d;
      }
    },
    handleCancel(ev) {
    // this.$emit("child", this.form);
          if (ev == 1) {
            this.$refs.ruleForm.validate((valid) => {
              if(valid){
                this.$emit("child", this.form);
                 if (this.form.notai) {
                  this.form.notai = this.form.notai.replace(/\+/g, '')
                }
                this.$ajax({
                  method: "post",
                  // url: "http://202.130.113.149:3785/admin/editQmisUserMsgFilePage",
                  url: this.$api.editQmisUserMsgFilePage,
                  data: {
                    username: this.form.securitiesAccount,
                    cn_name: this.form.chineseName,
                    en_name: this.form.englishName,
                    nationcode: this.form.notai,
                    phonenum: this.form.phoneNumber,
                    email: this.form.emailAddress,
                    id_number: this.form.identityInformation,
                    bank: this.form.bankName,
                    bank_number: this.form.bankNumber,
                    address: this.form.addressInformation,
                    nationality_en: this.form.nationality_en,
                    address_en: this.form.address_en,
                    residential_nationality_cn: this.form.residential_nationality_cn,
                    birth: this.formatDatefn(new Date(this.form.birth)),
                    flag: this.flag,
                  },
                }).then((res) => {
                  if (res.data.qmiscode == 1000) {
                    App.oTool.successT();
                    this.$router.go(0)
                  } else {
                    App.oTool.warningT(res.data.qmismsg);
                  }
                });
              }
            })
          }else{
            this.$emit("child", this.form);
          }


  
    },
  },
};
</script>

<style lang="scss">
  .qh_input .ant-input{
    border: none !important;
    height: 95% !important;
    box-shadow: none !important;
    padding: 0 !important;
    padding-left: 0 !important;
  }
  .qh_input .ant-input-affix-wrapper .ant-input:not(:first-child){
    padding-left: 0 !important;
  }
.phoneSty .ant-select-arrow {
  right: 6px !important;
}
.phoneSty .ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 28% ;
}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix {
  left: 2px !important;
  top: 18px;

}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 25.5px !important;
}
.phoneSty .ant-select-selection {
  border: 0 !important;
  height: 25px;
}
.phoneSty .ant-select-focused .ant-select-selection,
.ant-select-selection:active,
.ant-select-selection:focus {
  border: 0 !important;
  box-shadow: none !important;
}


.address .ant-form-item-label {
  width: 15% !important;
}
.address .ant-form-item-control-wrapper {
  width: 85% !important;
}
.content {
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 1rem;
  background-color: #fff;
  width: 38rem;
  margin: 0 auto;
  margin-bottom: 1rem;
  min-height: 50px;
}
#warp_sim12 .ant-modal-header,
#warp_sim12 .ant-modal-body {
  background-color: #e5e5e5 !important;
  padding: 1rem;
  padding-top: 0.7rem;
}

.mark-file {
  position: absolute;
  top: 0;
  left: 0;

  div {
    width: 6rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    display: inline-block;
  }
}

#warp_sim12 {
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-form-explain {
    display: none;
  }

  .ant-modal {
    top: 28%;
  }

  .ant-col-12 {
    text-align: right;
  }
  .myleft {
    text-align: left;
  }
  .ant-form-item-label {
    width: 30%;
  }

  .ant-form-item,
  .ant-form-item-control {
    width: 100%;

    .ant-calendar-picker {
      width: 100%;
    }
  }

  .ant-radio-group-default {
    width: 100%;
    margin-top: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 0.8rem;
    }
  }

  .ant-form-item-control-wrapper {
    width: 70%;

    .ant-form-item-control {
      width: 100%;
    }
  }

  #lastname {
    text-align: right;

    .ant-form-item-label {
      width: 10%;
    }

    .ant-form-item-control-wrapper {
      width: 86%;
    }
  }

  .ant-form-inline .ant-form-item {
    margin-right: 0;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-form-item {
    margin-bottom: 1rem;
  }

  .ant-form-item label {
    font-size: 0.8rem !important;
  }

  .ant-input {
    font-size: 0.8rem !important;
  }

  .ant-select-selection-selected-value {
    font-size: 0.8rem !important;
  }

  .ant-form-item-children {
    font-size: 0.8rem !important;
  }

  .ant-modal-body {
    padding: 0;
    padding-top: 2.5rem;
  }

  .btn1 {
    cursor: pointer;
    width: 8rem;
    height: 2rem;
    font-size: 0.8rem;
    color: #fff;
    border: 0;
    border-radius: 5px;
    margin: 0 3rem;
  }

  .btnx {
    background-color: #0c8b97;
  }

  .btn2 {
    background-color: #ed4849;
  }

  .mydivs {
    max-height: 7rem;
    overflow-y: auto;
    // margin-bottom: 1rem;
    padding: 1rem;
    margin-left: 4%;
    width: 96%;
    background-color: #f5f5f5;
    margin-bottom: 1rem;

    .c {
      font-size: 0.8rem;
    }

    .f {
      // text-align: right;
      display: flex;
      justify-content: space-between;
    }

    .t {
      margin: 0.5rem 0;
      border-bottom: 1px solid #d9d9d9;
    }
  }
}
</style>
